module.exports = __webpack_public_path__ + "img/ukrpol_image_presentation.a38bf459.webp";